function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, SimpleGrid, Stack, Flex } from '@tempo/core';
import { LandingHeading, LandingParagraph } from './LandingTypography';
export const LandingTextGrid = forwardRef((props, ref)=>{
    return /*#__PURE__*/ _jsx(SimpleGrid, _object_spread({
        ref: ref,
        columns: {
            base: 1,
            md: 3
        },
        spacing: {
            base: 'spacing.2xl',
            md: 'spacing.3xl'
        },
        w: "100%"
    }, props));
});
export const LandingTextGridItem = (props)=>{
    const { title, children, icon, titleAs = 'h3' } = props;
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: {
            base: 'spacing.m',
            md: 'spacing.xl'
        },
        direction: {
            base: 'column',
            md: 'row'
        },
        textAlign: {
            base: 'center',
            md: 'start'
        },
        children: [
            icon && /*#__PURE__*/ _jsx(Flex, {
                alignItems: "baseline",
                justifyContent: "center",
                fontSize: "6xl",
                children: icon
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: "spacing.m",
                children: [
                    /*#__PURE__*/ _jsx(LandingHeading, {
                        as: titleAs,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(LandingParagraph, {
                        children: children
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=LandingTextGrid.js.map